// "terms": [
//     {
//         "termsType": "PRV_LAUNDRYINST",
//         "termsID": "20200702001_KR",
//         "defaultLang": "ko",
//         "applyStartDate": "20200702",
//         "firstConsent": "Y",
//         "reConsent": "Y",
//         "termsTypeName": "개인정보 처리방침",
//         "requiredTermsID": "20200702001_KR",
//         "optionFlag": "N",
//         "mgtTpCode": "CHN",
//         "termUrlList": [
//             {
//                 "termLang": "ko",
//                 "url": "http://ngfts.lge.com/fts/gftsDownload.lge?biz_code=EMP_B2B&func_code=TERMS_HTML&file_path=/b2b/terms/html/20200702001_kr_20200702020014796_ko.html"
//             }
//         ]
//     }
// ]

interface TermUrl {
    termLang: string;
    url: string;
}

class LMPTerm {
    termsType: string;
    termsID: string;
    defaultLang: string;
    applyStartDate: string;
    firstConsent: "Y" | "N";
    reConsent: "Y" | "N";
    termsTypeName: string;
    requiredTermsID: string;
    optionFlag: "Y" | "N";
    mgtTpCode: string;
    termUrlList: TermUrl[];

    constructor({
        termsType,
        termsID,
        defaultLang,
        applyStartDate,
        firstConsent,
        reConsent,
        termsTypeName,
        requiredTermsID,
        optionFlag,
        mgtTpCode,
        termUrlList,
    }: {
        termsType: string;
        termsID: string;
        defaultLang: string;
        applyStartDate: string;
        firstConsent: "Y" | "N";
        reConsent: "Y" | "N";
        termsTypeName: string;
        requiredTermsID: string;
        optionFlag: "Y" | "N";
        mgtTpCode: string;
        termUrlList: TermUrl[];
    }) {
        this.termsType = termsType;
        this.termsID = termsID;
        this.defaultLang = defaultLang;
        this.applyStartDate = applyStartDate;
        this.firstConsent = firstConsent;
        this.reConsent = reConsent;
        this.termsTypeName = termsTypeName;
        this.requiredTermsID = requiredTermsID;
        this.optionFlag = optionFlag;
        this.mgtTpCode = mgtTpCode;
        this.termUrlList = termUrlList;
    }
}

export default LMPTerm;
